import * as React from 'react';
import text from '../../../utils/text';


interface Props {
  value: { service: string; fonction?: string };
  onChange: (value: any) => void;
}

interface State {
  check: boolean;
}

export default class ConsentSelector extends React.Component<Props, State> {
  state: State = { check: false }

  handleChange = (e: any) => {
    this.setState({ check: e.target.value })
    this.props.onChange(e.target.value);
  };

  public render() {

    const id = Math.random().toString(36).substring(7);

    return (
      <div className="checkbox">
        <input
          type='checkbox'
          id={id}
          checked={this.state.check}
          onChange={(e) => {
            this.handleChange({
              target: {
                name: e.target.name,
                value: e.target.checked,
              },
            });
          }}
        />
        <label htmlFor={id}>{text.free_mail_send}</label>
      </div>
    );
  }
}
